import { Inject, ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core'
import { Configuration } from './configuration'
import { HttpClient } from '@angular/common/http'

@NgModule({
    imports: [],
    declarations: [],
    exports: [],
    providers: [],
})
export class RegistrationApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<RegistrationApiModule> {
        return {
            ngModule: RegistrationApiModule,
            providers: [{ provide: Configuration, useFactory: configurationFactory }],
        }
    }

    constructor(@Inject(RegistrationApiModule) @Optional() @SkipSelf() parentModule: RegistrationApiModule,
                @Inject(HttpClient) @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('RegistrationApiModule is already loaded. Import in your base AppModule only.')
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
                'See also https://github.com/angular/angular/issues/20575')
        }
    }
}
